var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "instagramdefault-a",
    cx: "1.819%",
    cy: "90.845%",
    r: "144.605%",
    fx: "1.819%",
    fy: "90.845%",
    gradientTransform: "matrix(.99843 -.05234 .05233 .99863 -.048 .002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FED576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "26.34%",
    stopColor: "#F47133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60.91%",
    stopColor: "#BC3081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4C63D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "instagramdefault-b",
    cx: "1.814%",
    cy: "90.83%",
    r: "144.604%",
    fx: "1.814%",
    fy: "90.83%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FED576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "26.34%",
    stopColor: "#F47133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60.91%",
    stopColor: "#BC3081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4C63D2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagramdefault-a)",
    d: "M5.524.857A7.83 7.83 0 002.694 2.7 7.807 7.807 0 00.85 5.524C.454 6.536.188 7.698.11 9.399c-.078 1.7-.097 2.246-.097 6.582 0 4.335.02 4.88.097 6.581.078 1.7.35 2.863.74 3.875a7.83 7.83 0 001.844 2.83 7.83 7.83 0 002.83 1.844c1.012.396 2.174.662 3.875.74 1.7.078 2.246.097 6.582.097 4.335 0 4.88-.02 6.581-.097 1.7-.078 2.863-.35 3.875-.74a7.83 7.83 0 002.83-1.844 7.83 7.83 0 001.844-2.83c.396-1.012.662-2.174.74-3.875.078-1.7.097-2.246.097-6.581 0-4.336-.02-4.882-.097-6.582-.078-1.7-.35-2.863-.74-3.875A7.873 7.873 0 0029.274 2.7a7.83 7.83 0 00-2.83-1.843C25.43.46 24.269.195 22.569.117c-1.7-.078-2.246-.098-6.582-.098s-4.881.02-6.582.098C7.698.188 6.536.46 5.524.857zm16.908 2.129c1.558.071 2.402.33 2.967.552a4.974 4.974 0 011.837 1.194c.558.558.902 1.09 1.194 1.837.22.564.48 1.408.552 2.966.078 1.681.09 2.188.09 6.452 0 4.265-.019 4.77-.09 6.452-.072 1.558-.331 2.402-.552 2.966a4.974 4.974 0 01-1.194 1.837 4.974 4.974 0 01-1.837 1.195c-.565.22-1.409.48-2.967.551-1.68.078-2.187.091-6.451.091-4.265 0-4.771-.02-6.452-.09-1.558-.072-2.402-.332-2.967-.552a4.974 4.974 0 01-1.837-1.195 4.974 4.974 0 01-1.194-1.837c-.22-.564-.48-1.408-.552-2.966-.078-1.681-.09-2.187-.09-6.452 0-4.264.019-4.77.09-6.452.072-1.558.331-2.402.552-2.966a4.974 4.974 0 011.194-1.837 4.974 4.974 0 011.837-1.194c.565-.221 1.409-.48 2.967-.552 1.68-.078 2.187-.091 6.452-.091 4.264 0 4.77.013 6.451.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagramdefault-b)",
    d: "M7.783 15.987a8.198 8.198 0 108.198-8.198 8.194 8.194 0 00-8.198 8.198zm13.52 0a5.321 5.321 0 01-5.322 5.323 5.321 5.321 0 01-5.323-5.323 5.321 5.321 0 015.323-5.322 5.321 5.321 0 015.322 5.322z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.51,
    cy: 7.465,
    r: 1.915,
    fill: "#654C9F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramDefault);
export default __webpack_public_path__ + "static/media/InstagramDefault.63874871.svg";
export { ForwardRef as ReactComponent };